var mobileSearch = require('./components/mobileSearch/mobileSearch.js');

// Event Handlers
// new component architecture
function _registerEventHandlers() {
    $(document).ready(function () {
        mobileSearch.initialize();
    });
}
_registerEventHandlers();